import { Actions, ArrowRightIcon, FormGridContainer } from "@cpj-ai/panel-npm-package";
import { GetJobPositionByIdQuery } from "@graphql/generated";
import { useUpdateJobPosition } from "@modules/JobPosition/pages/AddJobPosition/useUpdateJobPosition";
import { useEffect } from "react";
import { FieldValues, useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { getInputConfig, requiredDocumentsOptions } from "./formConfig";

interface ISkillsStepContentProps {
  handleNextStep: () => void;
  jobPositionData?: NonNullable<NonNullable<GetJobPositionByIdQuery["organization"]>["jobPosition"]>["get"];
}

const SkillsStepContent = ({ handleNextStep, jobPositionData }: ISkillsStepContentProps) => {
  const formHandler = useForm();
  const { handleSubmit, loading: submitLoading } = useUpdateJobPosition();
  const [searchParams] = useSearchParams();

  formHandler.watch("minAge");
  formHandler.watch("maxAge");
  formHandler.watch("minWorkExperienceYears");
  formHandler.watch("maxWorkExperienceYears");

  const handleClickSubmit = formHandler.handleSubmit(async (data: FieldValues) => {
    try {
      const id = searchParams.get("id");
      if (!id) return;
      await handleSubmit({
        handleNextStep,
        id,
        values: {
          ...data,
          skills: data.skills?.map((skill: any) => skill.node.id),
          requiredDocuments: [
            ...(data.requiredDocuments || []),
            ...(typeof data.otherRequiredDocuments === "string" && data.otherRequiredDocuments.length > 0
              ? data.otherRequiredDocuments.split(",")
              : []),
          ],
          workExperienceYearsRange: [data.minWorkExperienceYears, data.maxWorkExperienceYears],
          ageRange: [data.minAge, data.maxAge],
        },
      });
    } catch (error) {
      console.error(error);
    }
  });

  useEffect(() => {
    if (jobPositionData) {
      const selectedDocuments: string[] = [];
      const otherRequiredDocuments: string[] = [];

      const availableOptionValues = new Set(requiredDocumentsOptions.map((option) => option.value));

      jobPositionData.requiredDocuments?.forEach((doc) => {
        if (availableOptionValues.has(doc)) {
          selectedDocuments.push(doc);
        } else {
          otherRequiredDocuments.push(doc);
        }
      });

      formHandler.reset({
        skills: jobPositionData.skills?.map((skill) => ({ node: skill })),
        degrees: jobPositionData.degrees,
        languages: jobPositionData.languages,
        nativeLanguages: jobPositionData.nativeLanguages,
        requiredDocuments: selectedDocuments,
        otherRequiredDocuments: otherRequiredDocuments.join(", "),
        performanceExpectation: jobPositionData.performanceExpectation,
        ...(jobPositionData?.workExperienceYearsRange && {
          minWorkExperienceYears: jobPositionData?.workExperienceYearsRange[0],
          maxWorkExperienceYears: jobPositionData?.workExperienceYearsRange[1],
        }),
        ...(jobPositionData.ageRange && { minAge: jobPositionData?.ageRange[0], maxAge: jobPositionData?.ageRange[1] }),
      });
    }
  }, [formHandler, jobPositionData]);

  return (
    <div className="mb-8">
      {/* <Typography className="font-bold">new Job Details :</Typography>
      <Typography className="text-xs mb-5 mt-3">
        In this section, define the basic information about the new job post, including the job title, description,
        number of vacancies, initial requirements, and the start date.
      </Typography> */}

      <FormGridContainer formHandler={formHandler} inputConfigs={getInputConfig({ formHandler })} />

      <Actions
        className="mt-6"
        showCancel={false}
        submitProps={{
          onClick: handleClickSubmit,
          isLoading: submitLoading,
          isDisabled: submitLoading,
          children: "Next",
          endContent: <ArrowRightIcon stroke="#fff" className="w-4 h-4" />,
        }}
      />
    </div>
  );
};

export default SkillsStepContent;
